const sessionStorageKeySet = {
  SHARED_CONTRACT: "shared_contract",
  SHARED_BOOKING: "shared_booking",
  SHARED_TASK: "shared_task",
  SHARED_SHIPMENT: "shared_shipment",
  CHAT_STATE: "chat_state",
};

export { sessionStorageKeySet };
